import React from 'react';

const CircleRightArrow = () => {
	return (
		<svg className='circle-right-arrow' xmlns='http://www.w3.org/2000/svg' width='21' height='21' viewBox='0 0 21 21'>
			<g fill='none' fillRule='evenodd'>
				<circle cx='10.5' cy='10.5' r='10.5' fill='#9B9B9B' />
				<circle cx='10.5' cy='10.5' r='9.5' fill='#ffffff' />
				<path fill='#9B9B9B' fillRule='nonzero' d='M9.816 6.1L8.7 7.196 12.064 10.5 8.7 13.804 9.816 14.9 14.3 10.5z' />
			</g>
		</svg>
	);
};

export default CircleRightArrow;
export { CircleRightArrow };
